<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="empresas"
        :headers="headers"
        :rotina-id="ID_TELA_DE_EMPRESA"
        :configurar="true"
        :loading="loading"
        @create="() => abrirDialogCriarEmpresa()"
        @update="(indice) => abrirDialogEditarEmpresa(indice)"
        @configure="(indice) => abrirDialogConfigurarFilial(indice)"
        @delete="(indice) => abrirDialogExcluirEmpresa(indice)"
      >
        <template #[`item.status`]="{ item }">
          <v-icon v-if="item.status" color="green">mdi-check</v-icon>
          <v-icon v-else color="red">mdi-close</v-icon>
        </template>
      </DataTableDeCrud>

      <DialogDeEdicaoDeEmpresa
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :empresa-param="empresaParam"
        :itens="itensParam"
        @confirmado="atualizarEmpresa"
      />

      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />
    </div>

    <DialogDeConfiguracaoDeFilialEmpresa
      :show-dialog-settings.sync="showDialogSettingsParam"
      :empresa="empresaSettingsParam"
    />

    <v-dialog v-model="dialogExcluirEmpresa" persistent max-width="380">
      <v-card>
        <v-card-title class="headline">Excluir</v-card-title>
        <v-card-text refs="empresaExclusao">
          Tem certeza que deseja remover a empresa
          <b> {{ empresaExclusao.nome }} </b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogExcluirEmpresa = false">Cancelar</v-btn>
          <v-btn color="green darken-1" text :loading="excluindo" @click="excluirEmpresa"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EmpresaService from '@/services/empresa/empresa'
import UFService from '@/services/uf/uf'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeEdicaoDeEmpresa from '@/components/empresas/DialogDeEdicaoDeEmpresa'
import DialogDeConfiguracaoDeFilialEmpresa from '@/components/empresas/DialogDeConfiguracaoDeFilialEmpresa'
import DataTableDeCrud from '@/components/DataTableDeCrud'
import SnackBar from '@/models/components/snackbar'
import Empresa from '@/models/empresa'
import { formataCpfCnpj } from '@/shareds/formatacoes'
import { ID_TELA_DE_EMPRESA } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeEmpresa,
    DialogDeConfiguracaoDeFilialEmpresa
  },
  data: () => ({
    name: 'TelaDeEmpresa',
    headers: [
      { text: 'Nome', value: 'nome' },
      { text: 'Documento', value: 'documento' },
      { text: 'UF', value: 'uf.sigla' },
      { text: 'Status', value: 'status' },
      { text: 'Observações', value: 'observacoes' }
    ],
    empresas: [],
    loading: false,
    excluindo: false,
    validForm: false,
    dialog: false,
    dialogExcluirEmpresa: false,
    operacao: '',
    showDialogParam: false,
    showDialogSettingsParam: false,
    empresaParam: new Empresa(),
    empresaExclusao: {},
    indiceEmpresaExclusao: 0,
    itensParam: {},
    empresaSettingsParam: {},
    snackbar: new SnackBar(),
    ID_TELA_DE_EMPRESA: ID_TELA_DE_EMPRESA
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadEmpresas()
        this.loadUFs()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar empresas cadastradas.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadEmpresas() {
      this.loading = true
      const response = await EmpresaService.getAll()
      this.empresas = response.map((item) => ({
        ...item,
        documento: formataCpfCnpj(item.documento)
      }))
      this.loading = false
    },

    async loadUFs() {
      const response = await UFService.getAll()
      this.itensUF = response.map((item) => ({ text: item.sigla, value: item.id }))
    },

    atualizarEmpresa(empresa) {
      if (!empresa) return

      empresa.documento = formataCpfCnpj(empresa.documento)

      const indice = this.empresas.findIndex(
        (empresaExistente) => empresaExistente.id === empresa.id
      )

      if (indice === -1) {
        this.empresas.push(empresa)
        this.snackbar.snackTextParam = 'Empresa criada com sucesso.'
      } else {
        this.empresas.splice(indice, 1, empresa)
        this.snackbar.snackTextParam = 'Empresa atualizada com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    async excluirEmpresa() {
      this.excluindo = true

      try {
        await EmpresaService.deleteById(this.empresaExclusao.id)
        this.snackbar.snackTextParam = 'Empresa removida com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true

        this.empresas.splice(this.indiceEmpresaExclusao, 1)
        this.dialogExcluirEmpresa = false
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined
            ? error.message
            : error.response.data.message
            ? error.response.data.message
            : 'Não foi possível excluir a empresa.'
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.excluindo = false
      }
    },

    abrirDialogCriarEmpresa() {
      this.operacao = 'adicionar'
      this.itensParam = { uf: this.itensUF, tipoICMS: this.itensTipoICMS }
      this.empresaParam = new Empresa()
      this.showDialogParam = true
    },

    abrirDialogEditarEmpresa(indice) {
      this.operacao = 'editar'
      this.itensParam = { uf: this.itensUF, tipoICMS: this.itensTipoICMS }
      this.empresaParam = { ...this.empresas[indice] }
      this.showDialogParam = true
    },

    abrirDialogConfigurarFilial(indice) {
      this.empresaSettingsParam = { ...this.empresas[indice] }
      this.showDialogSettingsParam = true
    },

    abrirDialogExcluirEmpresa(indice) {
      this.empresaExclusao = this.empresas[indice]
      if (!this.empresaExclusao.id) return

      this.indiceEmpresaExclusao = indice
      this.dialogExcluirEmpresa = true
    }
  }
}
</script>
